import { IProps } from './index'

const WristOx = ({ onConnect, onCancel }: IProps) => {
  return (
    <div
      className="reader-view"
      data-reader-view="device-instructions"
      data-device-type="n3150"
    >
      <h3 className="mb-6">
        <i className="fa fa-plug"></i>
        Instructions for connecting to your device
      </h3>
      <ul className="text-left">
        <li>
          <span>1</span> Be sure the WristOx USB cable is connected securely to
          your computer.
        </li>
        <li>
          <span>2</span> Tap the button on the top left side of the oximeter if
          the display is not on.
        </li>
        <li className="warning">
          <span>3</span> <small>IMPORTANT:</small> Be sure the display reads
          "CP" before resetting the oximeter.
        </li>
      </ul>
      <div className="flex justify-center items-center space-x-2 my-6">
        <button className="btn btn-default" onClick={onCancel}>
          <i className="fa fa-reply"></i>
          Reset Another Device
        </button>
        <button className="btn btn-primary" onClick={onConnect}>
          <i className="fa fa-download"></i>
          Reset Oximeter
        </button>
      </div>
    </div>
  )
}

export default WristOx
